import script from "./LgpdLegalBasisAndSignaturesConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./LgpdLegalBasisAndSignaturesConfig.vue?vue&type=script&setup=true&lang=js"

import "./LgpdLegalBasisAndSignaturesConfig.vue?vue&type=style&index=0&id=1760c50e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1760c50e"]])

export default __exports__